import * as yup from "yup";

export default t => yup.object().shape({
  name: yup.string().trim()
    .required(t("field_is_required"))
    .max(1000, "text_too_long"),
  scoreUnit: yup.string().trim()
    .required(t("field_is_required")),
});
